import React from "react"
import IconTrade from "@/assets/images/scheme/icon-trade.png";
import OverPack from "rc-scroll-anim/lib/ScrollOverPack";
import QueueAnim from "rc-queue-anim";
import Bg01 from "@/assets/images/product/construction/ev-bg01.jpg";
import Bg02 from "@/assets/images/product/construction/ev-bg02.jpg";
import Bg03 from "@/assets/images/product/construction/ev-bg03.jpg";
import Bg04 from "@/assets/images/product/construction/ev-bg04.jpg";
import Bg05 from "@/assets/images/product/construction/ev-bg05.jpg";
import Bg06 from "@/assets/images/product/construction/ev-bg06.jpg";
import Bg07 from "@/assets/images/product/construction/ev-bg07.jpg";


const EvaluationList = () => {
  return (
    <div className='warp-visit wrap-bank-list' style={{minHeight: '7600px', backgroundColor: '#FFFFFF'}}>
      <div className='wrap-bank-list-header'>
        <div className='wrap-bank-list-header-box home-page'>
          <img src={IconTrade} alt=""/>
          <div className='wrap-title'>全场景人才测评解决方案</div>
        </div>
      </div>
      <div className='wrap-bank-list-summary'>
        <div className='home-page'>
          <div className='warp-visit-content-items'>
            <div className='content-item' style={{padding: '0px'}}>
              <div className='content-item-block' style={{marginTop: '0px'}}>
                <div className='b-content p-pre-wrap'>
                  以战略导向的人才标准为起点，我们提供覆盖建模诊断、素质测评、面试评审三位一体的测评闭环服务——帮助企业在招聘甄选、盘点任用、发展储备等全场景中，让人才识别有依据、用人决策有底气。
                </div>
              </div>
            </div>
          </div>
          <div className='warp-visit-content-items'>
            <div className='content-item' style={{padding: '0px', marginTop: '60px'}}>
              <div className='content-item-block'>
                <div className='b-title' style={{marginBottom: '30px'}}>
                  三大应用场景
                </div>
                <img src={Bg01} alt="" width='1200px' key='img' />
              </div>
            </div>
          </div>
          <OverPack playScale={0.3}>
            <QueueAnim
              key="text"
              type="bottom"
              leaveReverse
              ease={['easeOutQuad', 'easeInQuad']}
              style={{minHeight: '549px', marginTop: '40px'}}
            >
              <div className='warp-visit-content-items' key='name'>
                <div className='content-item' style={{padding: '0px', marginTop: '60px'}}>
                  <div className='content-item-block'>
                    <div className='b-title'>
                      测评的逻辑 —— “真正的人才价值往往隐藏在水面之下”
                    </div>
                  </div>
                </div>
              </div>
              <img src={Bg02} alt="" width='1200px' key='img' />
            </QueueAnim>
          </OverPack>
          <OverPack playScale={0.3}>
            <QueueAnim
              key="text"
              type="bottom"
              leaveReverse
              ease={['easeOutQuad', 'easeInQuad']}
              style={{minHeight: '549px', marginTop: '60px'}}
            >
              <div className='warp-visit-content-items' key='name'>
                <div className='content-item' style={{padding: '0px', marginTop: '60px'}}>
                  <div className='content-item-block'>
                    <div className='b-title'>
                      我们提供的测评服务：
                    </div>
                  </div>
                </div>
              </div>
              <div style={{color: '#151515', fontSize: '20px', fontWeight: '600'}} key='title1'>
                1. 诊断：现状调研与建模
              </div>
              <div className='desc1' style={{margin: '24px 0'}}  key='desc1'>
                作为一切测评动作的起点，夯实标准与摸清底盘。<br /><br />
                调研诊断： 提供涵盖360度评估、员工敬业度与满意度调研、以及管理有效性诊断等服务，全面摸排组织现状。<br />
                经典建模：综合运用战略解码、岗位深度分析、高管访谈及焦点小组等专业方法，建立定制化能力素质模型。<br />
                快速建模： 依托标准胜任力词典库，通过小样本访谈实现模型的敏捷构建与校准。
              </div>
              <div style={{color: '#151515', fontSize: '20px', fontWeight: '600'}} key='title2'>
                2. 测量：素质与知识技能测评
              </div>
              <div className='desc2' style={{margin: '24px 0'}}  key='desc2'>
                结合线上与线下工具，多维透视冰山上下的真实水平。<br /><br />
                素质类测评：<br /><br />
                智力与认知测验： 基于行政能力测验题型的智力工具，可根据岗位需求定制难度。<br />
                场景化素质测验： 针对销售、数字化等关键岗位提供专属测评工具<br />
                高端定制服务：基于企业专属模型，定向开发测评报告与工具库。<br /><br />

                知识技能类测评：<br /><br />
                专业知识笔试： 深度解构目标岗位的知识结构，量身定制专业知识考核试题。<br />
                情景类测评： 围绕管理能力或岗位核心要求，设计高仿真度的情景判断试题。<br />
                案例类测评： 提供如公文筐测验等深度评价工具，基于目标岗位定制专属商业案例，考察综合研判能力。
              </div>
              <div style={{color: '#151515', fontSize: '20px', fontWeight: '600'}} key='title3'>
                3. 决断：面试与专家评审
              </div>
              <div className='desc2' style={{margin: '24px 0'}}  key='desc3'>
                聚焦关键少数与核心岗位，通过高频互动与专家研判锁定最终人选。<br /><br />
                深度面试：<br /><br />
                个体面试： 综合运用行为事件访谈（BEI）、述能考核、情境模拟、案例解析等多种形式。<br />
                群体面试： 组织实施无领导小组讨论、辩论会等高效的群面筛选形式。<br />
                沙盘模拟： 高端定制商业沙盘案例，以沉浸式工作坊形式，开展“测训一体”的沙盘推演游戏，在实战中观察干部。<br /><br />

                专家评审：<br /><br />
                资格评审： 紧贴业务需求设计，高效筛选候选人的任职资格底线。<br />
                评审组织赋能： 规划标准化的评审流程并提供配套工具表单，配套企业内部评审专家培训<br />
                评审参谋服务： 专家团队以独立第三方视角介入，整合测评数据与面试观察，向内部评审委员会输出客观、可追溯的综合评估意见。
              </div>
            </QueueAnim>
          </OverPack>
          <OverPack playScale={0.3}>
            <QueueAnim
              key="text"
              type="bottom"
              leaveReverse
              ease={['easeOutQuad', 'easeInQuad']}
              style={{minHeight: '549px', marginTop: '60px'}}
            >
              <div className='warp-visit-content-items' key='name'>
                <div className='content-item' style={{padding: '0px', marginTop: '60px'}}>
                  <div className='content-item-block'>
                    <div className='b-title'>
                      核心测评工具箱
                    </div>
                  </div>
                </div>
              </div>
              <div style={{color: '#151515', fontSize: '20px', fontWeight: '600'}} key='title'>
                01、CPI全面个性测评
              </div>
              <div className='desc' style={{margin: '24px 0'}}  key='desc'>
                定位： 深入洞察个体行为特质与内在驱动力，回答“这个人天生擅长什么、容易被什么所驱动” <br />
                适用场景： 招聘甄选、高潜识别、自我认知与发展规划<br />
                产品描述：CPI 以大五理论作为核心基础，结合艾森克：“三因素模型”、卡特尔16PF等经典人格理论，评估39项个性特质和31项胜任力水平，测评结果采用百分位数据。
              </div>
              <img src={Bg03} alt="" width='1200px' key='img' />
            </QueueAnim>
          </OverPack>
          <OverPack playScale={0.3}>
            <QueueAnim
              key="text"
              type="bottom"
              leaveReverse
              ease={['easeOutQuad', 'easeInQuad']}
              style={{minHeight: '549px', marginTop: '60px'}}
            >
              <div style={{color: '#151515', fontSize: '20px', fontWeight: '600'}} key='title'>
                02、MH10心理健康测评
              </div>
              <div className='desc' style={{margin: '24px 0'}}  key='desc'>
                定位： 前置预警用人风险，洞察员工心理健康状态，回答“个体能否保持良好的心理韧性并有效融入团队”。<br />
                适用场景： 关键岗位招聘甄选、高压/高危岗位盘点、员工心理健康普查与风险防范。<br />
                产品描述： 基于中国职业人士心理健康特点，结合“SDS”、“SAS”、“SCL90”等经典量表开发。精准测量焦虑、抑郁、偏执等10个最常见的心理健康因素。通过88道单选题完成自我评估，作答大约需要25分钟。
              </div>
              <img src={Bg04} alt="" width='1200px' key='img' />
            </QueueAnim>
          </OverPack>
          <OverPack playScale={0.3}>
            <QueueAnim
              key="text"
              type="bottom"
              leaveReverse
              ease={['easeOutQuad', 'easeInQuad']}
              style={{minHeight: '549px', marginTop: '60px'}}
            >
              <div style={{color: '#151515', fontSize: '20px', fontWeight: '600'}} key='title'>
                03、LSS领导风格测评
              </div>
              <div className='desc' style={{margin: '24px 0'}}  key='desc'>
                定位： 深入探究管理者的行为倾向，回答“管理者在带团队完成任务时，习惯采用何种管理风格”。<br />
                适用场景： 管理者盘点与任用、干部领导力发展培训、团队管理冲突诊断。<br />
                产品描述： 整合大量领导风格研究，以戈尔曼的理论为基础，评价管理者在计划、组织、激励、控制等任务中的行为特点。评估并识别管理者在6种领导风格（指令型、愿景型、亲和型、民主型、领跑型、教练型）上的主导和辅助类型。采取自评及下级评价相结合的方式，共36个题目，作答大概需要10分钟。
              </div>
              <img src={Bg05} alt="" width='1200px' key='img' />
            </QueueAnim>
          </OverPack>
          <OverPack playScale={0.3}>
            <QueueAnim
              key="text"
              type="bottom"
              leaveReverse
              ease={['easeOutQuad', 'easeInQuad']}
              style={{minHeight: '549px', marginTop: '60px'}}
            >
              <div style={{color: '#151515', fontSize: '20px', fontWeight: '600'}} key='title'>
                04、TCS团队氛围测评
              </div>
              <div className='desc' style={{margin: '24px 0'}}  key='desc'>
                定位： 全面衡量管理者的团队塑造水平，回答“当前团队氛围如何、员工感知到的管理现状与理想状态差异在哪里”<br />
                适用场景： 组织效能诊断、团队绩效归因分析、管理者领导力辅导与针对性提升。<br />
                产品描述： 基于“德鲁克经理人核心管理五任务”构建六大维度评估模型，全面评估下属感知到的团队氛围。通过对比员工对现状的评价以及对理想情况的期望，直观找到管理差异。采取自评及下级评价方式（上级20道题目，下级25道题目），作答大概需要10分钟。
              </div>
              <img src={Bg06} alt="" width='1200px' key='img' />
            </QueueAnim>
          </OverPack>
          <OverPack playScale={0.3}>
            <QueueAnim
              key="text"
              type="bottom"
              leaveReverse
              ease={['easeOutQuad', 'easeInQuad']}
              style={{minHeight: '549px', marginTop: '60px'}}
            >
              <div style={{color: '#151515', fontSize: '20px', fontWeight: '600'}} key='title'>
                05、360度能力素质评估
              </div>
              <div className='desc' style={{margin: '24px 0'}}  key='desc'>
                定位： 多维洞悉他人眼中真实的管理者画像，回答“该管理者在周围360度视角（上级、平级、下级）下的真实核心素质表现如何”。<br />
                适用场景： 关键干部提拔晋升参考、年终绩效综合评价、高管个人领导力觉察与发展。<br />
                产品描述： 运用BEST模型，根据6大维度32项胜任力词典构建专业评估题目，并在大量实践中积累了不同行业常模数据。高度关注作答体验，既支持一对一评估；若一人需评价多人，也可对一个问题同时给所有被评价人打分，大幅节约时间成本。
              </div>
              <img src={Bg07} alt="" width='1200px' key='img' />
            </QueueAnim>
          </OverPack>
        </div>
      </div>
    </div>
  )
}

export default EvaluationList